import React from 'react';
import useAvatar from 'vl-common/src/hooks/useAvatar';
import { useTranslation } from 'react-i18next';

const TimelineAvatar = ({ data }) => {
  const { t } = useTranslation('common');
  const avatar = useAvatar(data?.clin_user_guid || '');

  return (
    <div className="dr-part">
      {avatar && <img alt={t('avatar')} className="image" src={avatar} />}
      {!avatar && <div className="image" />}
      <div className="text-row">
        <div className="key">{t('Clinician:')}</div>
        <div className="value">{data.clinician_name}</div>
      </div>
    </div>
  );
};

export { TimelineAvatar };
